import { useState } from 'react';
import IconButton from '../../components/icon-button';
import caretWhiteLeft from '../../assets/images/caret-white-left.svg';
import Carousel from 'nuka-carousel';
import caretLeft from '../../assets/images/caret-left.svg';
import styles from './styles.module.scss';
import { CarouselImage } from 'components/image-carousel';

interface ImageObjectNotNavigateProps {
  onClose: () => void;
  images: CarouselImage[];
}

const ImageObjectNotNavigate = ({ onClose, images }: ImageObjectNotNavigateProps) => {
  const isCarouselInDetails = !!images;
  const imageHeight = 200;
  const [index, setIndex] = useState(0);

  const handleLeftButton = (previousSlide: any) => {
    previousSlide();
  };

  const handleRightButton = (nextSlide: any) => {
    nextSlide();
  };

  return (
    <div className={styles.container}>
      <header className={styles.header} style={{ position: 'absolute', top: '20px', left: 0 }}>
        <div className={styles.headerWrapper}>
          <IconButton icon={caretWhiteLeft} onClick={() => onClose()} />
        </div>
      </header>

      {isCarouselInDetails ? (
        <div className={styles.containerCarousel}>
          <Carousel
            swiping={false} // Disable swiping
            wrapAround
            enableKeyboardControls
            afterSlide={setIndex}
            disableEdgeSwiping={true}
            dragging={false}
            className={styles.carousel}
            renderCenterLeftControls={({ previousSlide }) =>
              images.length > 1 && (
                <IconButton
                  className={styles.leftIcon}
                  icon={caretLeft}
                  onClick={() => handleLeftButton(previousSlide)}
                />
              )
            }
            renderCenterRightControls={({ nextSlide }) =>
              images.length > 1 && (
                <IconButton
                  className={styles.rightIcon}
                  icon={caretLeft}
                  onClick={() => handleRightButton(nextSlide)}
                />
              )
            }
          >
            {images?.map((i: any, idx: any) => (
              <img src={i.src} alt={i.alt} key={idx} height={imageHeight} onClick={() => {}} />
            ))}
          </Carousel>

          <div className={styles.pageInfo}>{index + 1 + '/' + images.length}</div>
        </div>
      ) : (
        <img src={''} alt={''} key={1} />
      )}
    </div>
  );
};

export default ImageObjectNotNavigate;
